<script setup>
import { ref, computed } from 'vue';

import use$T from 'cfg/useTranslation';
const $t = use$T();

const props = defineProps({
  category: {
    type    : String,
    default : 'default',
  }
});

const openIndex = ref(0);

const questions = computed(()=> Object.entries($t.map(`@${props.category}`)).map(([id, {q, a}])=> ({
  id, q, a
})));

function toggle(index) {
  openIndex.value = openIndex.value === index ? -1 : index;
}

</script>

<template>
  <div class="faq-app">

    <div class="faq-list">
      <div v-for="(item, index) in questions" :key="item.id" class="faq-item" :class="{ open: openIndex === index }">

        <button class="faq-q" @click="toggle(index)" :aria-expanded="openIndex === index">
          <span v-html="item.q"></span>
          <span class="faq-icon" aria-hidden="true"></span>
        </button>
        <transition name="faq-collapse"
          @enter="(el)=> el.style.height = el.scrollHeight + 'px' "
          @after-enter="(el)=> el.style.height = ''"
          @before-leave="(el)=> el.style.height = el.scrollHeight + 'px' "
          @after-leave="(el)=> el.style.height = ''"
        >
          <div class="faq-a-wrap" v-show="openIndex === index">
            <div class="faq-a" v-html="item.a"></div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>

.faq-list
  display: flex
  flex-direction: column

.faq-item
  border-bottom: 1px solid var(--line, #E5E7E2)

  &:first-child
    border-top: 1px solid var(--line, #E5E7E2)

  &.open .faq-icon
    transform: rotate(45deg)

.faq-q
  display: flex
  align-items: center
  justify-content: space-between
  gap: 16px
  width: 100%
  padding: 22px 0
  font: inherit
  font-family: var(--display, sans-serif)
  font-size: 18px
  font-weight: 500
  letter-spacing: -0.01em
  text-align: left
  color: var(--ink, #0A1612)
  background: none
  border: 0
  cursor: pointer

.faq-icon
  flex-shrink: 0
  width: 16px
  height: 16px
  margin-left: 16px
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 2v12M2 8h12' stroke='%230A1612' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E")
  transition: transform .2s ease

.faq-a-wrap
  overflow: hidden

.faq-a
  padding: 0 0 22px
  font-size: 15px
  line-height: 1.65
  color: var(--muted, #6B7770)

  :deep(a)
    color: var(--brand-600, #20548B)
    text-decoration: underline
    text-underline-offset: 2px

.faq-collapse-enter-active,
.faq-collapse-leave-active
  transition: height .25s ease

.faq-collapse-enter-from,
.faq-collapse-leave-to
  height: 0 !important
</style>
